/** Upper bound for a single read-only startup check (status, session, version). */
export const STARTUP_CHECK_TIMEOUT_MS = 15_000;
